// Tabular variant configuration for each space category
// variantField: the field whose options become rows in the table
// variantOptions: predefined row options
// sharedFields: fields shown above the table (apply to all variants, e.g. multiselect)
// columns: fields rendered as table columns per variant row
// Every row also gets 'regular_price' and 'holiday_price' columns automatically

const VARIANT_CONFIG = {
  parking: {
    variantField: 'vehicle_type',
    variantLabel: 'Vehicle Type',
    variantOptions: ['Car', 'Bike', 'Heavy Vehicle', 'All Types'],
    columns: [
      { key: 'slot_count', label: 'Slots', type: 'number' },
      { key: 'covered_uncovered', label: 'Cover', type: 'select', options: ['Covered', 'Uncovered', 'Both'] },
      { key: 'ev_support', label: 'EV', type: 'toggle' },
      { key: 'height_restriction', label: 'Height', type: 'text', placeholder: '2.1m' },
      { key: 'valet_option', label: 'Valet', type: 'toggle' },
    ]
  },
  hotels: {
    variantField: 'room_type',
    variantLabel: 'Room Type',
    variantOptions: ['Single', 'Double', 'Twin', 'Suite', 'Deluxe', 'Dormitory', 'Villa'],
    columns: [
      { key: 'occupancy', label: 'Max Occ.', type: 'number' },
      { key: 'check_in_time', label: 'Check-in', type: 'time' },
      { key: 'check_out_time', label: 'Check-out', type: 'time' },
      { key: 'meal_plan', label: 'Meal Plan', type: 'select', options: ['None', 'Breakfast Only', 'Half Board', 'Full Board', 'All Inclusive'] },
      { key: 'room_service', label: 'Room Svc', type: 'toggle' },
    ]
  },
  gyms: {
    variantField: 'plan_name',
    variantLabel: 'Plan',
    variantOptions: ['Day Pass', 'Monthly', 'Quarterly', 'Annual'],
    sharedFields: [
      { key: 'equipment_types', label: 'Equipment Available', type: 'multiselect', options: ['Cardio', 'Free Weights', 'Machines', 'CrossFit', 'Yoga Mats', 'Boxing Ring', 'Swimming Pool'] },
    ],
    columns: [
      { key: 'personal_trainer', label: 'Trainer', type: 'toggle' },
      { key: 'locker_rooms', label: 'Lockers', type: 'toggle' },
      { key: 'shower', label: 'Shower', type: 'toggle' },
      { key: 'group_classes', label: 'Classes', type: 'toggle' },
    ]
  },
  yoga_wellness: {
    variantField: 'plan_name',
    variantLabel: 'Plan',
    variantOptions: ['Drop-in', 'Monthly', 'Quarterly', 'Annual'],
    sharedFields: [
      { key: 'session_types', label: 'Sessions Offered', type: 'multiselect', options: ['Hatha Yoga', 'Vinyasa', 'Power Yoga', 'Meditation', 'Pranayama', 'Sound Healing', 'Pilates', 'Tai Chi', 'Spa / Massage'] },
    ],
    columns: [
      { key: 'private_instructor', label: 'Instructor', type: 'toggle' },
      { key: 'locker_rooms', label: 'Lockers', type: 'toggle' },
      { key: 'shower', label: 'Shower', type: 'toggle' },
      { key: 'group_classes', label: 'Classes', type: 'toggle' },
    ]
  },
  astrology: {
    variantField: 'reading_type',
    variantLabel: 'Reading Type',
    variantOptions: ['Online Consultation', 'In-Person Consultation', 'Home Visit', 'Written Report'],
    sharedFields: [
      { key: 'astrology_systems', label: 'Astrology Systems Offered', type: 'multiselect', options: ['Vedic Astrology (Jyotish)', 'Western Astrology', 'Chinese Astrology (BaZi)', 'Tarot Reading', 'Numerology', 'Palmistry', 'KP Astrology', 'Nadi Astrology', 'Lal Kitab', 'Horary / Prashna', 'Hellenistic Astrology', 'Mayan Astrology', 'Celtic Astrology', 'Kabbalistic Astrology', 'Kundli / Horoscope Matching', 'Vastu Consultation', 'Feng Shui Reading', 'Rune Reading'] },
    ],
    columns: [
      { key: 'remedies', label: 'Remedies', type: 'toggle' },
      { key: 'written_report', label: 'Report', type: 'toggle' },
      { key: 'gemstone_advice', label: 'Gemstones', type: 'toggle' },
      { key: 'follow_up', label: 'Follow-up', type: 'toggle' },
    ]
  },
  hospital: {
    variantField: 'speciality',
    variantLabel: 'Speciality',
    variantOptions: ['General', 'Dental', 'Eye', 'Ortho', 'Cardiology', 'Dermatology', 'Paediatrics', 'Multi-Speciality'],
    columns: [
      { key: 'beds', label: 'Beds', type: 'number' },
      { key: 'ambulance', label: 'Ambulance', type: 'toggle' },
      { key: 'pharmacy', label: 'Pharmacy', type: 'toggle' },
      { key: 'lab', label: 'Lab', type: 'toggle' },
    ]
  },
  home: {
    variantField: 'furnishing',
    variantLabel: 'Furnishing',
    variantOptions: ['Fully Furnished', 'Semi Furnished', 'Unfurnished'],
    columns: [
      { key: 'bedrooms', label: 'Beds', type: 'number' },
      { key: 'bathrooms', label: 'Baths', type: 'number' },
      { key: 'kitchen', label: 'Kitchen', type: 'toggle' },
      { key: 'laundry', label: 'Laundry', type: 'toggle' },
      { key: 'balcony', label: 'Balcony', type: 'toggle' },
    ]
  },
  coworking: {
    variantField: 'desk_type',
    variantLabel: 'Desk Type',
    variantOptions: ['Hot Desk', 'Dedicated Desk', 'Private Cabin', 'Open Space', 'Virtual Office'],
    columns: [
      { key: 'monitors_available', label: 'Monitors', type: 'toggle' },
      { key: 'meeting_rooms', label: 'Meeting Rm', type: 'toggle' },
      { key: 'print_scan', label: 'Print', type: 'toggle' },
      { key: 'high_speed_internet', label: 'Hi-Speed', type: 'toggle' },
    ]
  },
  meeting_rooms: {
    variantField: 'layout',
    variantLabel: 'Layout',
    variantOptions: ['Boardroom', 'U-Shape', 'Classroom', 'Theatre', 'Flexible'],
    columns: [
      { key: 'seating_capacity', label: 'Seats', type: 'number' },
      { key: 'projector', label: 'Projector', type: 'toggle' },
      { key: 'whiteboard', label: 'Board', type: 'toggle' },
      { key: 'video_conferencing', label: 'Video', type: 'toggle' },
    ]
  },
  event_spaces: {
    variantField: 'event_type',
    variantLabel: 'Event Type',
    variantOptions: ['Wedding', 'Corporate', 'Birthday', 'Conference', 'Exhibition', 'Multi-Purpose'],
    columns: [
      { key: 'max_guests', label: 'Guests', type: 'number' },
      { key: 'stage', label: 'Stage', type: 'toggle' },
      { key: 'sound_system', label: 'Sound', type: 'toggle' },
      { key: 'catering_allowed', label: 'Catering', type: 'toggle' },
      { key: 'decoration_allowed', label: 'Decor', type: 'toggle' },
    ]
  },
  studios: {
    variantField: 'studio_type',
    variantLabel: 'Studio Type',
    variantOptions: ['Photography', 'Video/Film', 'Music/Recording', 'Dance', 'Podcast', 'Art/Painting'],
    columns: [
      { key: 'soundproofing', label: 'Soundproof', type: 'toggle' },
      { key: 'equipment_provided', label: 'Equipment', type: 'toggle' },
      { key: 'green_screen', label: 'Green Scr', type: 'toggle' },
      { key: 'lighting_setup', label: 'Lighting', type: 'toggle' },
    ]
  },
  storage: {
    variantField: 'storage_type',
    variantLabel: 'Storage Type',
    variantOptions: ['Self-Storage Unit', 'Warehouse', 'Locker', 'Container', 'Open Yard'],
    columns: [
      { key: 'unit_size', label: 'Size', type: 'text', placeholder: '10x10 ft' },
      { key: 'climate_controlled', label: 'Climate', type: 'toggle' },
      { key: 'access_hours', label: 'Access', type: 'select', options: ['24/7', 'Business Hours', 'Custom'] },
      { key: 'ground_floor', label: 'Ground', type: 'toggle' },
    ]
  },
  shops: {
    variantField: 'shop_type',
    variantLabel: 'Shop Type',
    variantOptions: ['Retail', 'Kiosk', 'Pop-up', 'Showroom', 'Service Centre'],
    columns: [
      { key: 'shop_area', label: 'Area (sqft)', type: 'number' },
      { key: 'display_area', label: 'Display', type: 'toggle' },
      { key: 'storage_room', label: 'Storage', type: 'toggle' },
      { key: 'power_backup', label: 'Power', type: 'toggle' },
    ]
  },
  malls: {
    variantField: 'footfall_area',
    variantLabel: 'Zone',
    variantOptions: ['High Footfall', 'Medium Footfall', 'Low Footfall', 'Food Court Area', 'Near Anchor Store'],
    columns: [
      { key: 'floor_level', label: 'Floor', type: 'text', placeholder: 'GF' },
      { key: 'escalator_access', label: 'Escalator', type: 'toggle' },
      { key: 'food_court_near', label: 'Food Court', type: 'toggle' },
      { key: 'mall_area', label: 'Area (sqft)', type: 'number' },
    ]
  },
  halls: {
    variantField: 'hall_type',
    variantLabel: 'Hall Type',
    variantOptions: ['Banquet Hall', 'Community Hall', 'Conference Hall', 'Marriage Hall', 'Exhibition Hall'],
    columns: [
      { key: 'dining_capacity', label: 'Capacity', type: 'number' },
      { key: 'stage_available', label: 'Stage', type: 'toggle' },
      { key: 'green_room', label: 'Green Rm', type: 'toggle' },
      { key: 'sound_system', label: 'Sound', type: 'toggle' },
    ]
  },
  housing_societies: {
    variantField: 'space_type',
    variantLabel: 'Space Type',
    variantOptions: ['Club House', 'Community Hall', 'Garden', 'Terrace', 'Parking Area', 'Party Area'],
    columns: [
      { key: 'residents_only', label: 'Residents', type: 'toggle' },
      { key: 'booking_approval', label: 'Approval', type: 'toggle' },
      { key: 'guard_available', label: 'Guard', type: 'toggle' },
    ]
  },
  religious_places: {
    variantField: 'faith_type',
    variantLabel: 'Type',
    variantOptions: ['Temple', 'Church', 'Mosque', 'Gurudwara', 'Multi-faith', 'Meditation Centre'],
    columns: [
      { key: 'ceremony_allowed', label: 'Ceremony', type: 'toggle' },
      { key: 'prasad_service', label: 'Prasad', type: 'toggle' },
      { key: 'shoe_rack', label: 'Shoe Rack', type: 'toggle' },
      { key: 'seating_capacity', label: 'Seats', type: 'number' },
    ]
  },
  salons: {
    variantField: 'salon_type',
    variantLabel: 'Salon Type',
    variantOptions: ['Hair Salon', 'Beauty Salon', 'Spa', 'Nail Studio', 'Barbershop', 'Unisex Salon'],
    columns: [
      { key: 'stations', label: 'Stations', type: 'number' },
      { key: 'wash_basins', label: 'Basins', type: 'number' },
      { key: 'styling_chairs', label: 'Chairs', type: 'number' },
      { key: 'products_provided', label: 'Products', type: 'toggle' },
    ]
  },
  clubs: {
    variantField: 'club_type',
    variantLabel: 'Club Type',
    variantOptions: ['Nightclub', 'Lounge Bar', 'Social Club', 'Members Club', 'Karaoke Bar', 'Pool/Billiards'],
    columns: [
      { key: 'dance_floor', label: 'Dance Flr', type: 'toggle' },
      { key: 'dj_setup', label: 'DJ', type: 'toggle' },
      { key: 'vip_section', label: 'VIP', type: 'toggle' },
      { key: 'age_restriction', label: 'Age Limit', type: 'text', placeholder: '21+' },
    ]
  },
  restaurants: {
    variantField: 'cuisine_type',
    variantLabel: 'Cuisine',
    variantOptions: ['Indian', 'Chinese', 'Italian', 'Continental', 'Japanese', 'Mexican', 'Multi-Cuisine', 'Cafe'],
    columns: [
      { key: 'seating_capacity', label: 'Seats', type: 'number' },
      { key: 'private_dining', label: 'Private', type: 'toggle' },
      { key: 'bar_available', label: 'Bar', type: 'toggle' },
      { key: 'outdoor_seating', label: 'Outdoor', type: 'toggle' },
    ]
  },
  sports: {
    variantField: 'sport_type',
    variantLabel: 'Sport',
    variantOptions: ['Cricket', 'Football', 'Badminton', 'Tennis', 'Basketball', 'Swimming', 'Table Tennis', 'Multi-Sport'],
    columns: [
      { key: 'court_count', label: 'Courts', type: 'number' },
      { key: 'equipment_rental', label: 'Equip', type: 'toggle' },
      { key: 'coaching_available', label: 'Coach', type: 'toggle' },
      { key: 'flood_lights', label: 'Lights', type: 'toggle' },
    ]
  },
  ev_charging: {
    variantField: 'charger_type',
    variantLabel: 'Charger',
    variantOptions: ['Level 1 (Slow)', 'Level 2 (Fast)', 'DC Fast Charging', 'Tesla Supercharger', 'Mixed'],
    sharedFields: [
      { key: 'connector_types', label: 'Connector Types', type: 'multiselect', options: ['Type 1 (J1772)', 'Type 2 (Mennekes)', 'CCS', 'CHAdeMO', 'Tesla', 'GB/T'] },
    ],
    columns: [
      { key: 'charging_speed', label: 'Speed', type: 'select', options: ['3.3 kW', '7.4 kW', '22 kW', '50 kW', '150 kW', '350 kW'] },
      { key: 'stations_count', label: 'Stations', type: 'number' },
      { key: 'reservation_available', label: 'Reserve', type: 'toggle' },
    ]
  },
  education: {
    variantField: 'class_type',
    variantLabel: 'Class Type',
    variantOptions: ['Online Live Class', 'Recorded Lecture', '1-on-1 Tutoring', 'Group Workshop', 'Course (Multi-session)'],
    sharedFields: [
      { key: 'subjects', label: 'Subjects Taught', type: 'multiselect', options: ['Maths', 'Science', 'English', 'Languages', 'Coding', 'Music', 'Art', 'Test Prep', 'Business', 'Finance', 'Other'] },
      { key: 'levels', label: 'Levels', type: 'multiselect', options: ['Pre-K', 'K-12', 'Undergraduate', 'Postgraduate', 'Adult Learner', 'All Levels'] },
    ],
    columns: [
      { key: 'duration_minutes', label: 'Duration (min)', type: 'number' },
      { key: 'max_students', label: 'Max Students', type: 'number' },
      { key: 'language', label: 'Language', type: 'text', placeholder: 'English' },
      { key: 'recording_included', label: 'Recording', type: 'toggle' },
      { key: 'certificate', label: 'Certificate', type: 'toggle' },
    ]
  }
};

export default VARIANT_CONFIG;
